import {
    FETCH_COMPANY_BUDGET_GROUPS,
    SAVE_BUDGET_GROUP,
    DELETE_BUDGET_GROUP,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COMPANY_BUDGET_GROUPS:
            return action.payload;
        case SAVE_BUDGET_GROUP:
            if (action.meta && action.meta.groupId) {
                return state.map(group => group.id === action.meta.groupId ? action.payload : group);
            }
            return state.concat(action.payload);
        case DELETE_BUDGET_GROUP:
            return state.filter(group => group.id !== action.payload.groupId);
        default:
            return state;
    }
};
